import * as React from 'react'
import {SubscriptionCancelled} from '../elements/SubscriptionCancelled'
import {FooterInfo} from '../elements/FooterInfo'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionCancelledBlock = () => (
  <section className="widget-block subscription-cancelled-block">
    <div className="widget-block-content">
      <SubscriptionCancelled />
    </div>
    <FooterInfo />
  </section>
)
